export function parseInvoiceBalance(balance) {
  if (balance == null || balance === '') return null;
  const normalized = Number(String(balance).replace(/,/g, '').trim());
  return Number.isFinite(normalized) ? normalized : null;
}

export function isInvoicePaid(balance) {
  const parsed = parseInvoiceBalance(balance);
  return parsed !== null && parsed <= 0;
}
